import './app';
// Child Theme Global Args
// const childThemeGlob = {
// 	$webSiteMainWrapper: $(webSiteWrapperSelector)
// };

// window.blockAPI = (() => {
// 	const blockAPI = {};

// 	return {
// 		add( apiName, api ) {
// 			if ( !(apiName in blockAPI) )
// 			{blockAPI[apiName] = api;}
// 		},
// 		run( apiName ) {
// 			if ( apiName in blockAPI )
// 			{return blockAPI[apiName];}
// 		}
// 	};
// })();

// const appChild = {
// 	customFunction: function() {

// 	},

// 	customFunctionResizeable: function() {

// 	}
// };


// const initializeChildFunctions = () => {
// 	for ( const func in appChild )
// 	{appChild[func]();}
// };

// const resizeChildFunctions = () => {
// 	for ( const func in appChild ) {
// 		if ( func.indexOf('Resizeable') !== -1 )
// 		{appChild[func]();}
// 	}
// };

// document.addEventListener( 'DOMContentLoaded', initializeChildFunctions );
// window.addEventListener( 'resize', resizeChildFunctions );

function checkConsent() {
	let jobAppConsent = document.getElementById( 'input_1_13_1' );

	if ( jobAppConsent ) {
		jobAppConsent.checked = true;
	}
}

document.addEventListener( 'DOMContentLoaded', checkConsent );

/**
 * Ninja Forms - Disable Past Dates in Advanced Datepicker For Specific Form
 */

document.addEventListener( 'DOMContentLoaded', function() {
	function initCustomDatePicker() {
	  const CustomDatePicker = function() {
			this.initialize();
	  };

	  CustomDatePicker.prototype = {
			initialize: function() {
		  const channel = Backbone.Radio.channel( 'flatpickr' );
		  this.listener = this.modifyDatepicker.bind( this );
		  channel.on( 'init', this.listener );
			},

			modifyDatepicker: function( dateObject ) {
		  const currentDate = new Date();
		  dateObject.set( 'minDate', currentDate );
			}
	  };

	  new CustomDatePicker();
	}

	const formSelectors = ['#nf-form-5-cont', '#nf-form-2-cont'];

	const formExists = () => formSelectors.some( selector => document.querySelector( selector ) );

	if ( formExists() ) {
	  initCustomDatePicker();
	} else {
	  const observer = new MutationObserver( function( mutations, observerInstance ) {
			if ( formExists() ) {
		  initCustomDatePicker();
		  observerInstance.disconnect();
			}
	  } );

	  observer.observe( document.body, { childList: true, subtree: true } );
	}
} );
